import { ReactNode, Suspense } from 'react';
import React from 'react';

import Loader from '../components/atoms/loader.component';

interface SuspenseWrapperProps {
  children: ReactNode;
}

class ChunkErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    const message = typeof error === 'object' && error && 'message' in (error as any)
      ? (error as any).message as string
      : '';
    // Detect chunk load failures and hard reload without cache
    if (/Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(message)) {
      if ('caches' in window) {
        caches
          .keys()
          .then((names) => names.forEach((n) => caches.delete(n)))
          .finally(() => {
            globalThis.location.reload();
          });
      } else {
        // Fallback when Cache API is not available
        globalThis.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <Loader isFullPage />;
    }
    return this.props.children as any;
  }
}

const SuspenseWrapper = (props: SuspenseWrapperProps) => {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<Loader isFullPage />}>{props.children}</Suspense>
    </ChunkErrorBoundary>
  );
};

export default SuspenseWrapper;
